import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { BlockItemShape } from '../propTypes'
import { getAllocationString, getStyleByDepth } from '../utils'
import { useVisualBlocksContext } from '../VisualBlocksContext'
import BlockItem from './BlockItem'
import { TreeBranch } from './TreeBranch'

export default function BlockItemSubBlocks ({ items, depth }) {
  const { styles, maxBlockDepth, setDdItem, hasDrilldown, drilldownKeyAccessor } = useVisualBlocksContext()
  const columnStyle = useMemo(
    () => getStyleByDepth(styles, 'columns', depth),
    [styles, depth]
  )

  const totalValue = useMemo(
    () => items.reduce((sum, item) => sum + item.value, 0),
    [items]
  )
  const openDrilldown = (item) => {
    setDdItem(item)
  }
  return (
    <>
      <TreeBranch />
      <div className='flex flex-col gap-2 flex-1' style={columnStyle}>
        {items?.map((item) => (
          <div
            key={item.id || item.label}
            className='flex flex-col flex-1 w-full'
            style={{
              flexBasis: getAllocationString(item.value, totalValue),
              minWidth: '200px',
              cursor: hasDrilldown && item.data.some(d => d[drilldownKeyAccessor]) ? 'pointer' : 'default'
            }}
            onClick={() => openDrilldown(item)}
          >
            <BlockItem
              depth={depth}
              label={item.label}
              value={item.value}
              color={item.color}
              labelLocation={maxBlockDepth >= depth ? 'outside' : 'inside'}
              details={item.details || []}
              labelSize='sm'
            />
          </div>
        ))}
      </div>
    </>
  )
}

BlockItemSubBlocks.propTypes = {
  items: PropTypes.arrayOf(BlockItemShape).isRequired,
  depth: PropTypes.number.isRequired
}
